<template>
  <div class="index-container">
    <keep-alive>
      <router-view v-if="
          userData.singleStatus !== 6 && userData.singleStatus !== 7 ||
          $route.name === 'Account'
        "/>
      <NotSingle v-else />
    </keep-alive>
    <template v-if="$route.name !== 'Activity'">
      <div class="footer">
        <router-link to="/" class="tab home-btn" :class="{'active': $route.name === 'Home'}">
          <span class="tab-icon"></span>
          <span class="tab-name">缘分</span>
        </router-link>
        <router-link to="/messages.html" class="tab messages-btn" active-class="active">
          <span class="tab-icon"></span>
          <span class="tab-name">消息</span>
          <span class="message-num" v-if="unreadCount">{{unreadCount}}</span>
        </router-link>
        <router-link to="/account.html" class="tab account-btn" active-class="active">
          <span class="tab-icon"></span>
          <span class="tab-name">我的</span>
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NotSingle from '@/components/common/notSingle.vue'
export default {
  name: 'Index',
  components: {
    NotSingle
  },
  data () {
    return {
      timer: null
    }
  },
  computed: {
    ...mapState({
      userData: 'userData'
    }),
    ...mapState('message', {
      unreadCount: 'unreadCount'
    })
  },
  methods: {
    ...mapActions('message', {
      fetchUnreadCount: 'fetchUnreadCount'
    }),
    handleUnreadCount () {
      this.fetchUnreadCount().then(
        () => {
          this.timer = setTimeout(this.handleUnreadCount, 20000)
        }
      )
    }
  },
  mounted () {
    this.handleUnreadCount()
  },
  destroyed () {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/constant.scss";
  .index-container {
    padding-bottom: $footerHeight;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 50%;
    padding: 0 80px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: $clientWidth;
    height: $footerHeight;
    border-top: 1px solid #dfdfdf;
    background: #f7f7fa;
    transform: translateX(-50%);
    .tab {
      position: relative;
      text-align: center;
    }
    .tab-name {
      color: #ababab;
      font-size: 20px;
    }
    .tab-icon {
      display: block;
      width: 52px;
      height: 52px;
      background: url('~@/assets/img/footer-icon.png') no-repeat;
      background-size: 163px auto;
    }
    .message-num {
      position: absolute;
      top: -4px;
      right: -16px;
      width: 30px;
      height: 30px;
      color: #fff;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      border-radius: 100%;
      background: #f75669;
    }
    .tab.active {
        .tab-name {
            color: $mainColor;
        }
    }
    .home-btn {
      .tab-icon {
        width: 59px;
        background-position: 0 0;
      }
      &.active {
        .tab-icon {
          background-position: 0 -52px;
        }
      }
    }
    .messages-btn {
      .tab-icon {
        background-position: -59px 0;
      }
      &.active {
        .tab-icon {
          background-position: -59px -52px;
        }
      }
    }
    .account-btn {
      .tab-icon {
        background-position: -111px 0;
      }
      &.active {
        .tab-icon {
          background-position: -111px -52px;
        }
      }
    }
  }
</style>
